// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { CPDFormatters } from '../../shared/services/cpd-formatters';
import { WebServices } from '../../shared/services/webServices';
//import { FormDataService2 } from '../../shared/services/formData2';
import { Helpers } from '../../shared/services/helpers';
import { FormAction } from '../../shared/classes/formAction';

//Only need this if you are going to be formatting into date strcutures, often used by calendars
//import { casNgbDateParserFormatter } from '../../shared/services/cas-NgbDateParserFormatter';

//Third Party
import moment from 'moment';
//import { NgbDatepickerConfig, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

//Libraries
import { BCGrowls } from '../../shared/library/bcGrowls';


//Config/Globals
import { Enums } from '../../shared/enums.js';
    
//Auth & Config
import { authToken } from '../../shared/authToken';


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
@Component({
    template : '<div class="narl-main-div" data-test-id="content_narratives_list">\n\n    <!--Title-->\n    <!--<div tabindex="0" class="nar-title-div"><h2>{{_title}}</h2></div>-->\n    <h2 tabindex="-1" class="narl-title-div">{{_title}}</h2>\n\n    <div style="margin:0 10px 15px 20px; font-style:italic">Select a narrative to manage.</div>\n    <div style="height:10px;"></div>\n\n    <!--Content Loading -->\n    <ng-template #loading>\n        <div class="narl-ui-content-loading">\n            <img src="public/cpd-images/loading.gif" />\n            <div style="margin-left:10px;">Loading...</div>\n        </div>\n    </ng-template>\n   \n    <!--Selected Practice Display-->\n    <div *ngIf="!_isLoading()" class="narl-ui-cell">\n        <div class="narl-ui-group-lbl" role="heading" aria-label="Asset"><h3>Asset</h3></div>\n        <div style="margin:10px 0 5px 10px;">\n            <span style="font-weight:bold;margin-right:5px;">Asset Code:</span><span>{{_selectedPractice?.practice_code}}</span>\n            <span style="font-weight:bold;margin:0 5px 0 20px;">Asset Name:</span><span>{{_selectedPractice?.practice_name}}</span>\n        </div>\n    </div>\n\n\n    <!--Content Div -->\n    <div *ngIf="!_isLoading(); else loading" class="narl-ui-row" style="flex-grow:1;">\n\n        <!-- Narratives Grid --------------------------------->\n        <cas-grid #narrativesGrid\n                  summary="{{_title}}"\n                  [settings]="narrativesGridSettings"\n                  (onRefreshClicked)="onGridRefreshClicked()"\n                  (onRowSelectionChanged)="onRowSelectionChanged()"\n                  (onPageChanged)="onPageChanged($event)"\n                  (onSearch)="onGridSearch($event)">\n        </cas-grid>\n\n\n\n        <!--Popups-->\n        <!--====================================================================================================-->\n        <!--POPUP INSTANCE CONTAINER-->\n        <!--When the Modal component inserts the Angular component that wraps the Bootstrap popups, it needs to go somewhere\n        where it will be cleared when the user navigates away from this page.  Note that the popup elements inserted here\n        are moved to the \'body\' when displayed and then moved back here when not (so the heat shield/backdrop is under them in z-order).-->\n        <div id="narratives_list_page_popups"></div>\n\n        <!--====================-->\n        <!-- End Narrative -->\n        <!--====================-->\n        <modal #popEndNarrative\n               containerId="narratives_list_page_popups"\n               title="End Narrative"\n               label="popEndNarrative">\n\n            <!--FVT-ID-->\n            <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_narratives_list_confirm_end_narrative"></section>\n\n            <!-- body -->\n            <section>\n                <div style="margin-bottom:5px;">\n                    <span style="font-weight:bold">Code: </span><span>{{_selectedNarrative?.practice_narrative_code}}</span>\n                </div>\n                <div class="cpd-ui-row">\n                    <div class="cpd-ui-cell" style="width:100%">\n                        <div class="cpd-ui-field-div">\n                            This action will permanently end this asset narrative on the next fiscal year rollover. If you wish to continue click the Save button.\n                        </div>\n                    </div>\n                </div>\n            </section>\n\n            <!-- footer -->\n            <footer>\n                <!--<button type="button" [attr.disabled]="IsNarrativeEndingPopupValid() ? null : \'disabled\'" class="btn btn-primary" (click)="EndNarrative();narrativesEndingPopup.Close();">Save</button>-->\n                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n                <button type="button" class="btn btn-primary" accesskey="s" data-dismiss="modal" (click)="endNarrative()"><u>S</u>ave</button>\n            </footer>\n        </modal>\n\n        <!--====================-->\n        <!-- Undo End Narrative -->\n        <!--====================-->\n        <modal #popUndoEndNarrative\n               containerId="narratives_list_page_popups"\n               title="Undo End Narrative"\n               label="popUndoEndNarrative">\n\n            <!--FVT-ID-->\n            <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_narratives_list_confirm_undo_end_narrative"></section>\n\n            <!-- body -->\n            <section>\n                <div style="margin-bottom:5px;">\n                    <span style="font-weight:bold">Code: </span><span>{{_selectedNarrative?.practice_narrative_code}}</span>\n                </div>\n                <div class="cpd-ui-row">\n                    <div class="cpd-ui-cell" style="width:100%">\n                        <div class="cpd-ui-field-div">\n                            This asset narrative will now remain active for the upcoming fiscal year. If you wish to continue click the Save button.\n                        </div>\n                    </div>\n                </div>\n            </section>\n\n            <!-- footer -->\n            <footer>\n                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n                <button type="button" class="btn btn-primary" accesskey="s" data-dismiss="modal" (click)="undoEndNarrative()"><u>S</u>ave</button>\n            </footer>\n        </modal>\n\n\n\n\n    </div>\n\n</div>\n\n\n\n\n\n\n\n',
    styles : ['.narl-main-div{display:flex;flex-direction:column;position:absolute;top:0px;right:0px;bottom:0px;left:0px}.narl-ui-row{position:relative;margin:15px 0 0 0;border-top:solid 1px #ccc}.narl-ui-cell{position:relative;background-color:#f0f0f0;border-radius:4px;border:solid 1px #b8b8b8;padding:10px 15px 10px 15px;margin:0 10px}.narl-ui-group-lbl{position:absolute;top:-8px;left:5px;background-color:#d4e2f2;border-radius:4px;border:solid 1px #b8b8b8;padding:1px 8px;box-shadow:1px 1px 5px rgba(0,0,0,0.3)}.narl-ui-content-loading{display:flex;font-style:italic;margin:10px 20px}.narl-title-div{margin:10px 8px 15px 8px;padding-bottom:4px;border-bottom:solid 1px #b8b8b8}'],
    providers:[ ]
})
export class NarrativesListComponent {

    // INPUTS/OUTPUTS/COMPONENTS
    //-------------------------------------------------------------------------------------------------------------------------
    @ViewChild('narrativesGrid') narrativesGrid;
    @ViewChild('popEndNarrative') popEndNarrative;
    @ViewChild('popUndoEndNarrative') popUndoEndNarrative;

	//Class wide member reference for the growls control
	growlBox = null;
    

    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    // Boiler Plater
    _allFieldsDisabled = false;
    _componentName = 'narrativesList.js';
    _disposalFunctions = [];
    _formName = "narratives_list";
    _loading = true;
    _sessionStorageObject = null;
    _title = "";
    _now = moment();

    //BL
    _selectedPractice = null;
    _selectedNarrative = null;
    _selectedPracticeState = null;
    _currentFY = null;

    
    //Grid settings
    narrativesGridSettings = {
        //rowsPerPage : 25,
        hideClearSelectedButton:true,
        hideSearchBox:false,
        rowIdentifyForJAWS:true,
        rowIdentityFieldForJAWS:"practice_narrative_code",
        rowIdentityPrefixForJAWS:"Narrative Code",
        showCheckboxColumn:true,
        positionAbsolute:true,

        columns : [
            //{ fieldName:'state_abbr', display:'Level', width:'5%', minWidth:50 },
            //{ fieldName:'state_county_code', display:'Location', width:'5%', minWidth:75 },
            { fieldName:'practice_narrative_code', display:'Code', width:'8%', minWidth:50 },
            //{ fieldName:'practice_narrative_id', display:'Narrative Id', width:'5%', minWidth:100 },
            //{ fieldName:'start_date', display:'Start Date', width:'5%', minWidth:75, procDataFn: (start_date) => { return this.cpdFormatters.formatDateString(start_date) } },
            { fieldName: 'start_date', display: 'Start Date', width: '5%', minWidth: 75, procDataFn: (start_date, row) => { return this._procStartDateField(start_date, row); } },
            { fieldName: 'end_date', display: 'End Date', width: '5%', minWidth: 75, procDataFn: (end_date, row) => { return this._procDateField(end_date, row); } },
            { fieldName:'publish', display: 'Published', width: '5%', minWidth: 75 },
            { fieldName:'has_revisions', display:'Has Revisions', width:'5%', minWidth:75, procDataFn: (bVal) => { return bVal ? 'Y' : 'N'} },
            { fieldName:'end_on_rollover', display:'Ending on Rollover', width:'5%', minWidth:75, procDataFn: (bVal) => { return bVal ? 'Y' : 'N'} },
            { fieldName: 'practice_narrative', display: 'Narrative Text', width: '60%', procDataFn: (practice_narrative, row) => { return row.revision_narrative || practice_narrative; } }
        ],
        rows : []
    }

    _pageUrl = '';

    //An event listener handler method that will have "this" prebound so removeListener will work (which can't handle
    //removing a listener if it was bound in the registration)
    _boundKeypressHandler = null;


    // INITIALIZATION/LIFECYCLE
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(
        casNavBoxService: CASNavBoxService, 
        cpdFormatters: CPDFormatters,
        //formDataService: FormDataService2,
        helpers: Helpers,
        route:ActivatedRoute,
        router:Router,
        webServices: WebServices){

        this.constructor.mapParams(this, arguments);

        this._pageURL = this.router.url;

		// Growl Prep
		//--------------------
		this.growlBox = new BCGrowls("growlBox");
		this.growlBox.init({ 
			appendToElementId:"cpdesGrowlContainer" //cpdesGrowlContainer defined in \Nrcs.Cpdes.Ui\src\cpdes\components\cpdes.html
		}); 

        //Init page
        this._markPageAsLoading(true);

        //Init local storage
        this._sessionStorageObject = this._loadSessionStorageObject();
        if (!this._sessionStorageObject) {

            this._sessionStorageObject = {
                selectedNarrativeId:null,
                currentPage:1
            }
            this._saveSessionStorageObject(this._sessionStorageObject);
        }
        
        //Handle nav menu events
        this._disposalFunctions.push( casNavBoxService.OnActionClicked$.subscribe( action => {
            this.NavBoxActionClicked(action);
        }));

        //Add region & title
        // There is currently only a national narratives list
        this._title = "Manage Narratives - National - Narratives List";


        // Debugging
        //-------------------------------------------
        casNavBoxService.ClearDebugEntries();
        casNavBoxService.DebugEntries.push("Dump Local Storage");
        let disposer = casNavBoxService.OnDebugEntryClicked$.subscribe( entry => {
            this._debugEntryClicked(entry);
        });
        this._disposalFunctions.push(disposer);

        //Keypress Handler
        //-------------------------------------------
        //Prebind the listener (not using this here, keep for later)
        //this._boundKeypressHandler = this._handleGlobalKeypress.bind(this);

        //Register the handler globally to keyup
        window.addEventListener("keyup", this._boundKeypressHandler);
    }

    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy(){
        this._disposalFunctions.map( x => x.unsubscribe() );
        window.removeEventListener("keyup", this._boundKeypressHandler);
    }
    
    //==================================
    // ngOnInit
    //==================================
    ngOnInit() {
        this.set508();
        this.performAsyncOperations();
        //this.setNavBoxActions();
    };

    //==================================
    // ngOnInit_Complete
    //==================================
    ngOnInit_Complete() {
        this.setNavBoxActions();
        this.LoadNarratives(() => {
            this._markPageAsLoading(false);
        });   
    }

    // FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // set508
    //==================================
    set508() {
        window.setTimeout(() => {
            document.getElementById("accAlertAssertive").innerText = "Loading page data";

            let el = document.getElementsByClassName("narl-title-div")[0];
            if (el) { el.focus(); }
        }, 0);
    }

    //==================================
    // performAsyncOperations
    //==================================
    performAsyncOperations() {
        //Number of async ops this function has left to complete
        var ops = 3;

        // PARAMS
        //(note that this is a snapshot and will not change without a page reload)
        //(use rxjs if you need to react to changes. Ex: https://kamranahmed.info/blog/2018/02/28/dealing-with-route-params-in-angular-5/)
        var selectedPracticeId = this.route.snapshot.params.practiceId;

        //Load the practice for the indicated practiceId
        this.webServices.Get({
            apiPath: "/practices/getPractice",
            args: { practiceId: selectedPracticeId }
        })
            .then(res => {

                console.log("[{0}:_loadData():/practices/getPractice] - res:".format(this._componentName), res);

                if (res.data.Success) {
                    this._selectedPractice = res.data.DTO;

                    //Done?
                    if (--ops == 0) { this.ngOnInit_Complete(); }
                }
                else {
                    this.growlBox.addGrowl("error", this.cpdFormatters.formatError(res.data.ErrorMessage));
                }
            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            });

        //LOAD CURRENT FISCAL YEAR
        this.loadFY((dto) => {
            this._currentFY = dto;
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

        //LOAD Practice State Id - for navigation to CAPP
        this.loadPracticeState(selectedPracticeId, (dto) => {
            this._selectedPracticeState = dto[0];
            if (--ops == 0) { this.ngOnInit_Complete(); }
        })
    }

    //==================================
    // setNavBoxActions
    //==================================
    setNavBoxActions() {
        let actions = [];

        switch (authToken.user.role) {

            case Enums.Roles.NHQNationalPracticeDataSteward.id:
                actions.push(new FormAction("act_add_narrative", "Add Narrative"));
                actions.push(new FormAction("act_end_narrative", "End Narrative"));
                actions.push(new FormAction("act_undo_end_narrative", "Undo End Narrative"));
                actions.push(new FormAction("act_edit_narrative", "Edit Narrative "));
                //Only load Manage Narratives if practice_state_id is returned since it is needed for redirect
                if (this._selectedPracticeState != null) { 
                    actions.push(new FormAction("act_manage_narratives", "Manage Narratives - CAPP", true, "Manage Narratives CAPP for current Asset"));
                }
                break;

            default:
                break;
        }

        if (this.router.url.startsWith(this._pageURL)) {
            //Tell the shared navBoxCommService what the current actions are (will update the navBox actions)
            this.casNavBoxService.Actions = actions;
            this.casNavBoxService.ActionsLoading = false;
        }
    }

    //==================================
    // LoadNarratives
    //==================================
    LoadNarratives(fnOnComplete){
        
        this._markGridAsLoading(true);

        //Load the narratives for the selected practice
        this.webServices.Get({
            apiPath: "/narrative/getNarrativeList",
            args: { 
                practiceId: this._selectedPractice.practice_id,
                includeUnpublished: true
            }
        })
        .then( (res) => {
            console.log("[{0}:LoadNarratives():/narrative/getNarrativeList] res:".format(this._componentName), res);
            this._setGridRows(res.data.DTO);
            this._markGridAsLoading(false);
            this._sortGrid("practice_narrative_code", "A");
            if (fnOnComplete) { fnOnComplete(); }
        } )
        .catch( (err) => { 
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err) );
            this._markGridAsLoading(false);
            if (fnOnComplete) { fnOnComplete(); }
        });
    
    }

    //=======================================
    // loadFY
    //=======================================
    loadFY(fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/fiscalyear/getCurrentFiscalYear"
        })
            .then(res => {
                console.log("[{0}:loadFY():/fiscalyear/getCurrentFiscalYear] - res:".format(this._componentName), res);
                let dto = res.data.DTO;
                try {
                    if (fnOnComplete) { fnOnComplete(dto); }
                }
                catch (err) {
                    this.growlBox.addGrowl("error", "An unexpected error has occurred");
                    console.log("[ERROR][{0}:loadFY()]".format(this._componentName), err);
                    return;
                }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                if (fnOnError) { fnOnError(); }
            });
    }

    //=======================================
    // loadPracticeState
    //=======================================
    loadPracticeState(practiceId, fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/practices/getNationalStatePracticeDetails",
            args: {
                practiceId: practiceId
            }
        })
            .then(res => {
                console.log("[{0}:loadPracticeState():/practices/getNationalStatePracticeDetails] - res:".format(this._componentName), res);
                let dto = res.data.DTO;
                try {
                    if (fnOnComplete) { fnOnComplete(dto); }
                }
                catch (err) {
                    this.growlBox.addGrowl("error", "An unexpected error has occurred");
                    console.log("[ERROR][{0}:loadPracticeState()]".format(this._componentName), err);
                    return;
                }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                if (fnOnError) { fnOnError(); }
            });
    }

    //==================================
    // onGridSearch
    //==================================
    onGridSearch(searchText) {

        //This is for readability
        let searchFilterName = "search";
        let applyImmediately = true;

        //If the search box is empty, clear the filter
        if (!searchText || searchText.length == 0){
            this.narrativesGrid.ClearFilter(searchFilterName, applyImmediately);
            this.sendJawsNotification("The list has updated");
            return;
        }

        //Create the filter function
        let fnFilter = (row) => {
            //console.log("row.practice_narrative.toLowerCase().indexOf(searchText):", row.practice_narrative.toLowerCase().indexOf(searchText));
            return (row.practice_narrative_code.toLowerCase().indexOf(searchText) >= 0 || row.practice_narrative.toLowerCase().indexOf(searchText) >= 0);
        };

        //Set the "search" filter on the grid
        this.narrativesGrid.SetFilter(searchFilterName, fnFilter, applyImmediately);
        this.sendJawsNotification("The list has updated");
    }

    //=======================================
    // sendJawsNotification
    //=======================================
    sendJawsNotification(message) {
        $("#accLivePolite").empty();
        $("#accLivePolite").append(`<p>${message}</p>`);
    }

    // UI HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // endNarrative
    //==================================
    endNarrative() {
     
        this._markGridAsLoading(true);

        this.webServices.Post(
            "/narrative/endNarrative",
            { 
                practice_narrative_id: this._selectedNarrative.practice_narrative_id,
            }
        )
        .then( (res) => {
            console.log("[{0}:endNarrative():/narrative/endNarrative] res:".format(this._componentName), res);
            this._selectedNarrative.end_on_rollover = true;
            this._selectedNarrative = null;
            this.LoadNarratives(); //clears "grid loading"
        } )
        .catch( (err) => { 
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err) );
            this.LoadNarratives(); //clears "grid loading"
        });
    }

    //==================================
    // NavBoxActionClicked
    //==================================
    NavBoxActionClicked(action){

        switch (action.field_name) {

            case "act_add_narrative":
                //Pass the practiceId, as that will be the parent for the new narrative
                this.router.navigate(["/cpdes/practices/narrativeAdd/" + this._selectedPractice.practice_id]);
                break;

            case "act_edit_narrative":

                //Make sure a narrative has been selected
                if (!this._selectedNarrative) {
                    this.growlBox.addGrowl("info", "No row selected");
                    return;
                }

                //check if narrative is no longer active
                if (moment(this._selectedNarrative.end_date) < this._now) {
                    this.growlBox.addGrowl("info", "The selected narrative has already ended, and cannot be edited.");
                    return;
                }

                //check if narrative is flaged to be ended
                //if (this._selectedNarrative.end_on_rollover) {
                //    this.growlBox.addGrowl("info", "The selected narrative is flagged to be ended on the next fiscal year rollover.");
                //    return;
                //}

                // Check the published status to determine whether to make a revision or to edit the original narrative
                if (this._selectedNarrative.publish !== "Y") {
                    this.router.navigate(["/cpdes/practices/narrativeEdit/" + this._selectedPractice.practice_id + "/" + this._selectedNarrative.practice_narrative_id]);
                } else {
                    this.router.navigate(["/cpdes/practices/narrativeRevise/" + this._selectedPractice.practice_id + "/" + this._selectedNarrative.practice_narrative_id]);
                }

                break;

            case "act_end_narrative":

                //Make sure a narrative has been selected
                if (!this._selectedNarrative) {
                    this.growlBox.addGrowl("info", "No row selected");
                    return;
                }

                //check if narrative already ended
                if (this._selectedNarrative.end_on_rollover) {
                    this.growlBox.addGrowl("info", "The selected narrative is already flagged to be ended on the next fiscal year rollover.");
                    return;
                }

                //check if narrative is no longer active
                if (moment(this._selectedNarrative.end_date) < this._now) {
                    this.growlBox.addGrowl("info", "The selected narrative has already ended.");
                    return;
                }

                this.popEndNarrative.Open();
                
                break;

            case "act_undo_end_narrative":

                //Make sure a narrative has been selected
                if (!this._selectedNarrative) {
                    this.growlBox.addGrowl("info", "No row selected");
                    return;
                }

                //check if narrative is no longer active
                if (moment(this._selectedNarrative.end_date) < this._now) {
                    this.growlBox.addGrowl("info", "The selected narrative has already ended.");
                    return;
                }

                //check if narrative already not ended
                if (!this._selectedNarrative.end_on_rollover) {
                    this.growlBox.addGrowl("info", "The selected narrative is already not flagged to be ended on the next fiscal year rollover.");
                    return;
                }

                this.popUndoEndNarrative.Open();

                break;

            case "act_manage_narratives":

                // Navigate to this asset in CAPP Module
                let cappRoute = "/cpdes/capp/dashboard/{0}/{1}".format(this._currentFY.fiscalYear, this._selectedPracticeState.practice_state_id);
                this.router.navigate([cappRoute]);

                break;

            //case "act_view_narrative":
            //    break;
        }
    }

    //==================================
    // onGridRefreshClicked
    //==================================
    onGridRefreshClicked(){
        this.LoadNarratives();
    };

    //==================================
    // onPageChanged
    //==================================
    // $event will contain the new page
    onPageChanged($event) {

        var newPage = $event;
    
        //Store the new page in the local storage
        this._sessionStorageObject.currentPage = newPage;
        this._saveSessionStorageObject(this._sessionStorageObject);
    }

    //==================================
    // onRowSelectionChanged
    //==================================
    onRowSelectionChanged(){

        if (this.narrativesGrid) {
            this._selectedNarrative = this.narrativesGrid.GetFirstSelectedRow();

            if (this._selectedNarrative) {
                this._sessionStorageObject.selectedNarrativeId = this._selectedNarrative.practice_narrative_id;
                this._saveSessionStorageObject(this._sessionStorageObject);

            }
            else {
                this._sessionStorageObject.selectedNarrativeId = null;
                this._saveSessionStorageObject(this._sessionStorageObject);
            }
        }
    }

    //==================================
    // undoEndNarrative
    //==================================
    undoEndNarrative() {

        this._markGridAsLoading(true);

        this.webServices.Post(
            "/narrative/undoEndNarrative",
            {
                practice_narrative_id: this._selectedNarrative.practice_narrative_id,
            }
        )
            .then((res) => {
                console.log("[{0}:undoEndNarrative():/narrative/undoEndNarrative] res:".format(this._componentName), res);
                this._selectedNarrative.end_on_rollover = false;
                this._selectedNarrative = null;
                this.LoadNarratives(); //clears "grid loading"
            })
            .catch((err) => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                this.LoadNarratives(); //clears "grid loading"
            });
    }


    // PRIVATE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _disableUI
    //==================================
    _disableUI(){
        this.casNavBoxService.DisableAllLinks();
        this._allFieldsDisabled = true;
    };

    //==================================
    // _enableUI
    //==================================
    _enableUI(){
        this.casNavBoxService.EnableAllLinks();
        this._allFieldsDisabled = false;
    };

    //==================================
    // _formatDate
    //==================================
    _formatDate(dateString){
        return this.cpdFormatters.formatDateString(dateString);
    };

    ////==================================
    //// _getTitle
    ////==================================
    //_getTitle() {
    //}

    //==================================
    // _handleGlobalKeypress
    //==================================
    //_handleGlobalKeypress(e){
    //};

    //==================================
    // _isLoading
    //==================================
    _isLoading() {
        return this._loading || this.casNavBoxService.ActionsLoading;
    }

    //==================================
    // _loadSessionStorageObject
    //==================================
    _loadSessionStorageObject() {
        var obj = sessionStorage.getItem(this._formName);
        return obj ? JSON.parse(obj) : null;
    }

    //==================================
    // _markGridAsLoading
    //==================================
    // The grid is not always fully loaded when we want to interact with it,
    // so here well test and see if we need to change the underlying settings
    // or the loaded object.
    _markGridAsLoading(isLoading) {

        if (this.narrativesGrid){
            this.narrativesGrid.MarkAsLoading(isLoading);
        }
        else{
            this.narrativesGridSettings.loading = isLoading;
        }
    }

    //==================================
    // _markPageAsLoading
    //==================================
    _markPageAsLoading(isLoading) {
        this._loading = isLoading;
    }

    //==================================
    // _procStartDateField
    //==================================
    // This function processes each value in the start_date column in the grid
    _procStartDateField(start_date, row) {
        return !!start_date ? this.cpdFormatters.formatDateString(start_date) : row.publish_mode == 1 ? "Pending" : "Rollover";
    }

    //==================================
    // _procDateField
    //==================================
    // This function processes each value in the start_date column in the grid
    _procDateField(date, row) {
        return !!date ? this.cpdFormatters.formatDateString(date) : "";
    }

    //==================================
    // _saveSessionStorageObject
    //==================================
    _saveSessionStorageObject(obj) {
        if (!obj) { throw "[{0}:_saveSessionStorageObject] - obj must not be empty".format(this._componentName) }
        sessionStorage.setItem(this._formName, JSON.stringify(obj));
    }

    //==================================
    // _setGridRows
    //==================================
    // The grid is not always fully loaded when we want to interact with it,
    // so here well test and see if we need to change the underlying settings
    // or the loaded object.
    _setGridRows(data) {

        if (this.narrativesGrid){
            this.narrativesGrid.SetRows(data);
        }
        else{
            this.narrativesGridSettings.rows = data;
        }
    }

    //==================================
    // _sortGrid
    //==================================
    _sortGrid(column, direction) {

        // Let's give the grid a chance to render for a bit and then sort
        // once it comes up.  Keep it tight though, or we'll sort too long
        // after the grid comes up.
        this.helpers.executeOnCondition(
            () => { return !!this.narrativesGrid; },
            () => { this.narrativesGrid.SortGrid(column, direction); },
            50, 10
        );

    }


    // DEBUGGING
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _debugEntryClicked
    //==================================
    _debugEntryClicked(entry){
        console.log("[narratives:_debugEntryClicked]");
        console.log("    ", entry);

        switch (entry){ 
            case "Dump Local Storage":
                console.log(this._sessionStorageObject);
        }
    };

}

